jQuery(document).ready(function ($) {
    'use strict';

    $('.ram').each(function () {
        $(this).prepend('<div class="outer-border"></div><div class="inner-border"></div><div class="top-corners"></div><div class="bottom-corners"></div>');
    });

});